import { Helmet } from "react-helmet-async";

import { Layout } from "../components/Layout";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { Services } from "../components/sections/Services";
import { Trust } from "../components/sections/Trust";
import { Contact } from "../components/sections/Contact";

import { SEO_CONFIG } from "../seo/seoConfig";

export default function Home() {
  const seo = SEO_CONFIG.home;

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="robots" content={seo.robots} />
        <link rel="canonical" href={seo.canonical} />
        {seo.hreflang?.map((h) => (
          <link key={h.lang} rel="alternate" hrefLang={h.lang} href={h.href} />
        ))}

        {/* OG */}
        <meta property="og:locale" content={seo.og.locale} />
        <meta property="og:type" content={seo.og.type} />
        <meta property="og:site_name" content={seo.og.siteName} />

        <meta property="og:title" content={seo.og.title} />
        <meta property="og:description" content={seo.og.description} />
        <meta property="og:url" content={seo.og.url} />
        <meta property="og:image" content={seo.og.image} />
        <meta property="og:image:secure_url" content={seo.og.image} />
        <meta property="og:image:type" content={seo.og.imageType} />
        <meta property="og:image:width" content={String(seo.og.imageWidth)} />
        <meta property="og:image:height" content={String(seo.og.imageHeight)} />
        <meta property="og:image:alt" content={seo.og.imageAlt} />

        {/* Twitter */}
        <meta name="twitter:card" content={seo.twitter.card} />
        <meta name="twitter:title" content={seo.twitter.title} />
        <meta name="twitter:description" content={seo.twitter.description} />
        <meta name="twitter:image" content={seo.twitter.image} />
      </Helmet>

      <Layout>
        <Hero />
        <About />
        <Services />
        <Trust />
        <Contact />
      </Layout>
    </>
  );
}
